import { createContext } from 'react';

import { UserSession } from '../../api/types/UserData';

interface UserSessionData {
    userData?: UserSession;
}

const DEFAULT_PAGE_CONTEXT: UserSessionData = {
    userData: undefined
};

const UserSessionContext = createContext<UserSessionData>(DEFAULT_PAGE_CONTEXT);

export default UserSessionContext;
